import { Mensajes } from './../components/shared/mensajes';
import { Usuario } from './../modelo/usuario.model';
import { catchError, map, mapTo } from 'rxjs/operators';
import { Observable, throwError, of, fromEvent } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpHandler, HttpRequest, HttpInterceptor, HttpEvent, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { merge } from 'rxjs';
// import { Observable } from 'rxjs/Observable';
// import 'rxjs/Rx';
import { AuthService } from './auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class UrlBaseInterceptor implements HttpInterceptor {

  datosUser: Observable<Usuario>;
  // usuario: Usuario = {};
  token: string;
  online$: Observable<boolean>;
  conexion: boolean;


  constructor(public auth: AuthService, private _snackBar: MatSnackBar, private msj: Mensajes) {

    this.online$ = merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(mapTo(true), map(() => true)),
      fromEvent(window, 'offline').pipe(mapTo(false), map(() =>  false))
    );

    this.online$.subscribe(

      data  => {
        this.conexion = data;
      }

    );




  }
  intercept(req: HttpRequest<any>, next: HttpHandler, ): Observable<HttpEvent<any>> {
    // CREO LAS CABECERAS

    // CLONO LA REQUEST Y LE INYECTO LA CABECERA
    this.token = this.auth.getToken;



    if (this.conexion) { // tiene conexion a internt
      // tslint:disable-next-line: max-line-length
      if (this.token && this.token !== undefined && !req.url.includes('api.ipify.org') && !req.url.includes('https://api.pagos360.com')) {
        const headers = new HttpHeaders({
          // 'Content-Type': 'application/json',
          jwt: `${this.token}`,
        });

        const reqClone = req.clone({ headers });

        return next.handle(reqClone).pipe(
          catchError(this.handleError)
        );
      } else {
        return next.handle(req).pipe(
          catchError(this.handleError)
        );
      }
    } else { // no está conectado a internt
      this.msj.mensaje('Compruebe su conexión a internet, no es posible conectarse al servidor. Vuelva a recargar la página cuando tenga conexión.', 'Cerrar', 'E', 3000);
      return next.handle(req).pipe(
          catchError(this.handleError)
        );

    }

  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Error en cliente o falta.
      // console.error('Error del lado cliente: ', error.statusText);
      return throwError(error.error);
    } else {
      // Respuesta del Backend
      // console.error(
      //   `Mensaje del Backend = Código: ${error.status}, Descripción: ${error.statusText}`);
      return throwError(error.error);
    }
  }

}
